import { FormEvent, useState } from 'react'
import classes from './ChatWidget.module.scss'
import FeatureModal, { ModalFeedback, ModalLoading } from './FeatureModal'
import GuaranteeCard from './GuaranteeCard'
import { getChatErrorMessage } from './chatFormatters'
import { ChatRequestHandler, GuaranteeDetail } from './types'

interface Props {
  onClose: () => void
  onRequest: ChatRequestHandler
}

export default function GuaranteeInquiryModal({ onClose, onRequest }: Props) {
  const [serialNumber, setSerialNumber] = useState('')
  const [detail, setDetail] = useState<GuaranteeDetail | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [emptyMessage, setEmptyMessage] = useState<string | null>(null)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    const normalizedSerialNumber = serialNumber.trim()
    if (!normalizedSerialNumber) {
      setError('Seri numarası zorunludur.')
      return
    }
    if (loading) return

    setError(null)
    setEmptyMessage(null)
    setDetail(null)
    setLoading(true)
    try {
      const response = await onRequest({
        buttonIntent: 'getGarantiSorgu',
        buttonParameters: { serialNumber: normalizedSerialNumber },
      })
      if (response.guaranteeDetail) {
        setDetail(response.guaranteeDetail)
      } else {
        setEmptyMessage(response.text || 'Bu seri numarası için garanti kaydı bulunamadı.')
      }
    } catch (requestError: unknown) {
      setError(getChatErrorMessage(requestError, 'Garanti bilgisi şu anda sorgulanamıyor.'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <FeatureModal
      titleId='guarantee-inquiry-modal-title'
      title='Garanti Sorgu'
      description='Ürünün garanti ve fatura bilgilerini seri numarasıyla kontrol edin.'
      onClose={onClose}
      busy={loading}
    >
      <form className={classes.modalQueryForm} onSubmit={handleSubmit} noValidate>
        <label className={classes.modalField}>
          <span className={classes.modalFieldLabel}>Seri numarası</span>
          <div className={classes.modalInlineField}>
            <input
              data-modal-initial-focus
              className={classes.modalInput}
              value={serialNumber}
              onChange={event => {
                setSerialNumber(event.target.value)
                setError(null)
              }}
              placeholder='Seri numarasını girin'
              autoComplete='off'
              required
              disabled={loading}
            />
            <button type='submit' className={classes.modalPrimaryButton} disabled={loading || !serialNumber.trim()}>
              Sorgula
            </button>
          </div>
        </label>
      </form>

      {loading && <ModalLoading label='Garanti bilgisi sorgulanıyor…' />}
      {error && <ModalFeedback tone='error'>{error}</ModalFeedback>}
      {emptyMessage && <ModalFeedback tone='empty'>{emptyMessage}</ModalFeedback>}

      {detail && <GuaranteeCard detail={detail} titleId='guarantee-result-title' />}
    </FeatureModal>
  )
}
